import { Button, Card, HSpacer, Text, VSpacer } from '@/components/DesignSystem';
import { Routes } from "@/constants/Routes";
import { ToastMessages } from '@/constants/constant';
import { QueryKeys } from '@/constants/QueryKeys';
import { SaveSubwalletButton } from '@/components/shared/Subwallet/SaveSubwalletButton';
import { useSnackbar } from '@/providers/GlobalSnackbarProvider';
import { DetailedApiError } from '@/utilities/api/DetailedApiError';
import { RetailerApi } from '@/utilities/api/RetailerApi';
import { ApiRetailer } from '@api/interfaces';
import { Stack } from '@mui/material';
import React from 'react';
import { useNavigate } from "react-router-dom";
import { useQueryClient } from 'react-query';

interface ManageSubwalletCardProps {
  retailer: ApiRetailer,
}

export const ManageSubwalletCard = ({
  retailer,
}: ManageSubwalletCardProps) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { openSnackbar } = useSnackbar();

  return (
    <Card elevation={0} testID="manage-subwallet-card">
      <Stack alignItems="center" direction="row" justifyContent="space-between">
        <Stack>
          <Text category="title-small">
            Manage Wallet
          </Text>
          <VSpacer size="2" />
          <SaveSubwalletButton
            onSaveSubwallet={async (subwalletId) => {
              try {
                await RetailerApi.update(retailer.id, { programSubwalletId: subwalletId });
                await queryClient.invalidateQueries([QueryKeys.GET_RETAILER_BY_ID]);
                openSnackbar(ToastMessages.retailerUpdated);
              } catch (err) {
                if (err instanceof DetailedApiError) {
                  openSnackbar(err.message);
                }
              }
            }}
            retailer={retailer}
          />
        </Stack>
        <Stack alignItems="center" direction="row" justifyContent="space-between">
          <HSpacer size="3" />
          <Button
            color="primary"
            onClick={() => (
              navigate(Routes.RETAILER_WALLET.replace(':id', retailer.id))
            )}
            testID="manage-wallet-button"
            variant="outlined"
          >
            View
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
};
